import { connect } from 'react-redux';
import { flagEnabled } from '../redux/flags/selectors';
import { initialFetch } from './redux/actions';
import { getCanUserHaveWatchedGroups, getMainNavItems, getIsNetworkBarInitialized, getCanUserHaveRecommendedGroups } from './redux/selectors';
import { getCanUserSeeWatch, getIsMobile } from '../publicSession/selectors';
const mapStateToProps = (state)=>({
        showWatchedGroupsEmptyState: !getCanUserHaveWatchedGroups(state),
        showRecommendedGroups: getCanUserHaveRecommendedGroups(state),
        showCreateGroup: flagEnabled(state, 'eclipsed_groups'),
        mainNavItems: getMainNavItems(state),
        isInitialized: getIsNetworkBarInitialized(state),
        canSeeOldWatch: getCanUserSeeWatch(state),
        canSeeShop: getIsMobile(state)
    });
const mapDispatchToProps = {
    initialFetch
};
export default connect(mapStateToProps, mapDispatchToProps);
